import DateTimePickers from "components/mui5/DateTimePickers";
import moment from "moment";
import { useCallback } from "react";
import { useField } from "formik";
import { DatePickerProps } from "@mui/x-date-pickers-pro";
import { useTranslation } from "react-i18next";
import PickersTextField from "components/mui5/DateTimePickers/PickerTextField";

interface FormDatePickerProps extends DatePickerProps {
  name: string;
}

/**
 * @deprecated use FormDatePicker in components/Inputs/Form/FormDatePicker instead.
 */
function FormDatePicker(props: FormDatePickerProps) {
  const { t } = useTranslation();
  const [field, meta, helpers] = useField<string | null>(props.name);

  const hasError = Boolean(meta.touched && meta.error);
  const errorText = hasError ? t(meta.error as string) : null;

  const onChange = useCallback(
    (v: string | moment.Moment | null) => {
      helpers.setTouched(true);
      helpers.setValue(moment(v).toISOString());
    },
    [helpers]
  );

  return (
    <DateTimePickers.DatePicker
      {...props}
      name={field.name}
      format="DD / MM / YYYY"
      value={field.value ? moment(field.value) : null}
      onChange={onChange}
      slots={{ ...props?.slots, textField: PickersTextField }}
      slotProps={{
        ...props?.slotProps,
        field: { ...props?.slotProps?.field, onBlur: () => helpers.setTouched(true) },
        textField: {
          helperText: errorText,
          error: hasError,
          ...props?.slotProps?.textField,
        },
      }}
    />
  );
}

export default FormDatePicker;
